<template>
    <div class="top-bar">
        <div class="top-bar-section"></div>
        <div class="top-bar-section">
            <h1 id="top-bar-title" class="top-bar-title">SAR Tool{{ serviceName ? ' (' + serviceName + ')' : '' }}</h1>
        </div>
        <div class="top-bar-section">
        <button class="btn btn-link logout-button" @click="logout">Log Out</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'top-bar',
    props: ['serviceName'],
    methods: {
        logout() {
            this.$emit('logout');
        },
    },
};
</script>

<style lang="scss" scoped>
  .top-bar-section {
      flex: 1;
      display: flex;
      align-items: center;
  }
  .top-bar {
      background-color: #343a40;
      display: flex;
      padding: 4px 8px;
      min-height: 40px;
      margin: 0;
      color: white;
      .top-bar-title {
          font-size: 1.25rem;
          font-weight: normal;
          margin: 0 auto;
      }
      .logout-button {
          margin-left: auto;
          color: white;
      }
  }
</style>
